<template>
    <!-- 弹窗展示数据 -->
    <a-modal 
        :width="props.width" 
        v-model:visible="props.show" 
        centered 
        :title="props.title || '-'" 
        @cancel="cancel" 
    >
        <div class="content_box">
            <!-- 查看详情 -->
            <template v-if="state.checkState==1 || state.checkState==3">
                <div class="data_box">
                    <div class="txt_box">
                        <div class="s1">准考证号：</div>
                        <a-input 
                            style="width: 300px" 
                            v-model:value="state.data.examTicketNum" 
                            placeholder="请输入准考证" 
                            :disabled="state.signEditState" 
                        />
                    </div>

                    <UploadBox 
                        :fileList="state.data.signUpImages" 
                        @change="uploadChange($event, 'signUpImages')"
                        :disabled="state.signEditState"
                    >
                        <span v-if="!state.signEditState">最多上传6张图片，包括：考生证明、工作（实习）证明</span>
                        <span v-else>提交时间：{{state.data.signUpTime || "-"}}</span>
                    </UploadBox>

                </div>
            </template>
            <template v-if="props.data.checkState==2 || props.data.checkState>3">
                <!-- <div class="title">缴费凭证</div> -->
                <UploadBox 
                    :fileList="state.data.payImages" 
                    @change="uploadChange($event, 'payImages')"
                    :disabled="state.payEditState"
                >
                    <span v-if="!state.payEditState">上传付款成功截图作为凭证，务必清晰可见</span>
                    <span v-else>提交时间：{{state.data.payTime || "-"}}</span>
                </UploadBox>
            </template>
        </div>
        <template #footer>
            <div class="btn_box">
                <div class="left">
                    <span v-if="state.data.payCheckEmployeeId">{{state.data.payCheckNoPassMsg}}</span>
                    <span v-else>{{state.data.checkNoPassMsg}}</span>
                </div>
                <a-button style="margin-right: 5px;" v-if="state.cancelText" @click="cancel">取消</a-button>
                <a-button type="primary" @click="handleOk" :loading="state.loading">{{state.okText}}</a-button>
            </div>
        </template>
    </a-modal>
</template>

<script setup>
import { ref, reactive, watch } from "vue"; 
import UploadBox from "@/views/my_page/components/upload_box.vue"; 
import { imgUrlList } from "@/views/my_page/index.js"; 
import { paperMajorPayUpload, paperMajorReSignUp } from "@/api/my_page/paper"; 
import { message, Modal } from 'ant-design-vue';
const props = defineProps({
    width: {
        type: Number || String,
        default: 750
    }, 
    title: {
        type: String,
    }, 
    show: {
        type: Boolean,
        default: false
    }, 
    data: {
        type: Object,
        default: ()=>{
            return {}
        }
    },
})
const emit = defineEmits([ "update:show", "updateList", "okChange", "cancel" ]); 

let state = reactive({
    loading: false, 
    okText: "确定", 
    cancelText: false, 
    checkState: null, 
    data: { 
        examTicketNum: "", // 准考证号 
    }, 

    signUpImages: "", 
    payImages: "", 

    signEditState: true, // 报名禁用 
    payEditState: true, // 缴费禁用 
});
watch(() => props.data, newVal => {
    if (newVal) {
        // console.log("==========", newVal, newVal.checkState);
        state.checkState = newVal.checkState; 
        state.data = {
            ...newVal, 
        }

        // 修改报名禁用状态 
        // if (newVal.checkState == 1 || newVal.checkState == 3) {
        if (newVal.checkState == 3) {
            state.signEditState = false; 
            state.cancelText = true; 
        } else if (newVal.checkState == 2 || newVal.checkState == 6) { // 修改缴费禁用状态 
            state.payEditState = false; 
            state.cancelText = true; 
        } else {
            state.signEditState = true; 
            state.payEditState = true; 
            state.cancelText = false; 
        }
    }
}, { deep: true })

// 图片上传事件 
function uploadChange(params, key) { 
    // console.log("上传的图片路径", params, key); 
    state[key] = params; 
} 
// 上传付费凭证 
function payVoucher() {
    if (!state.payImages) {
        message.error("请上传付费凭证")
        return 
    }
    Modal.confirm({
    title: "提示",
    content: "确定后无法修改，请确认后再进行提交",
    onOk: () => {
        let params = {
            paperStudentMajorId: props.data.id, 
            payImages: state.payImages, 
        }; 
        state.loading = true; 
        paperMajorPayUpload(params).then(() => { 
            state.loading = false; 
            cancel(); 
            updateList(); 
        }).catch((err) => { 
            state.loading = false; 
            console.log("err====", err); 
        }); 
    },
    });
}

// 重新报名 
function signUpChange() {
    if (!state.data.examTicketNum) {
        message.error("请输入准考证号")
        return 
    }
    let params = {
        // paperStudentMajor: props.data.id, 
        // id: props.data.id, 
        paperStudentMajorId: props.data.id, 
        examTicketNum: state.data.examTicketNum, 
        signUpImages: state.signUpImages, 
    }; 

    state.loading = true; 
    paperMajorReSignUp( params ).then(res => {
        state.loading = false; 
        cancel(); 
        updateList(); 
    }).catch(err => {
        state.loading = false; 
        console.log("err==", err);
    })
}

function handleOk() { 
    // 没有取消按钮 触发关闭 
    if (!state.cancelText) {
        cancel(); 
    } else { 
        if (state.checkState == 2 || state.checkState == 6) {
            payVoucher(); // 上传付费凭证 
        } else if (state.checkState == 3) {
            signUpChange(); // 重新报名 
        }
    } 
} 

function cancel() {
    emit("update:show", false); 
}
function updateList() {
    emit("updateList"); 
}

</script>

<style lang="less" scoped>
.content_box {
    width: 100%;
    min-height: 200px;
    max-height: 60vh;
    overflow: auto;
    .data_box {
        padding-bottom: 10px;
        .txt_box {
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            .s1 {
                width: max-content;
            }
        }
    }
    .title {
        margin-top: 20px;
        font-weight: 600;
    }
    .btn_box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left {
            flex: 1;
            color: #ffa500;
        }
    }
}

</style>